module.exports = __webpack_public_path__ + "components/modal-app-popup/static/opera-icon-13c842c100f4261397a2b610ee203f9a.webp";